export var encodeSearchTerm = function encodeSearchTerm() {
  var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return term.split(" ").map(function (term) {
    return encodeURIComponent(term);
  }).join("+");
};